module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-margin-top"
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-wrap"
  }, [_c('div', {
    staticClass: "uk-width-1-2@m",
    attrs: {
      "id": "visit-notifications"
    }
  }, [_c('h4', [_vm._v("Wyślij wiadomość")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin uk-width-3-4@m"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageTxt),
      expression: "messageTxt"
    }],
    staticClass: "uk-textarea",
    attrs: {
      "rows": "5",
      "placeholder": "Wpisz wiadomość",
      "id": "messageInp"
    },
    domProps: {
      "value": (_vm.messageTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messageTxt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-margin",
    attrs: {
      "id": "selectedFiles"
    }
  }, _vm._l((_vm.files), function(file, key) {
    return _c('div', {
      staticClass: "file-listing"
    }, [_vm._v("\n            " + _vm._s(file.name) + "\n            "), _c('span', {
      staticClass: "uk-label uk-label-danger",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.removeFile(key)
        }
      }
    }, [_vm._v("Usuń")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('div', {
    attrs: {
      "uk-form-custom": ""
    }
  }, [_c('input', {
    ref: "files",
    attrs: {
      "type": "file",
      "id": "files",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary",
    attrs: {
      "type": "button",
      "tabindex": "-1"
    }
  }, [_vm._v("Dodaj załączniki")])]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary",
    on: {
      "click": function($event) {
        _vm.submitForm()
      }
    }
  }, [_vm._v("Wyślij")])])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2@m uk-overflow-auto",
    attrs: {
      "id": "visit-documents"
    }
  }, [_c('h4'), _vm._v(" "), _c('carousel', {
    attrs: {
      "auto": 5000,
      "watch-items": _vm.list
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('carousel-item', {
      key: item.url
    }, [_c('img', {
      attrs: {
        "src": item.url
      }
    })])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-width-2-2@m uk-margin-top",
    attrs: {
      "id": "visit-questionnaire"
    }
  }, [_c('h4', {
    staticStyle: {
      "margin-top": "0px !important"
    }
  }, [_vm._v("Nazwa i adresy kliniki oraz informację")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Nazwa kliniki:")]), _vm._v(" " + _vm._s(_vm.config.clinic_info.name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Adres:")]), _vm._v(" " + _vm._s(_vm.config.clinic_info.street) + ", " + _vm._s(_vm.config.clinic_info.postal_code) + ", " + _vm._s(_vm.config.clinic_info.city))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Opis:")]), _vm._v(" " + _vm._s(_vm.config.clinic_info.description))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15a83713"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Contact.vue
// module id = 267
// module chunks = 1